
var sprite = require("/data/jenkins/jobs/deploy_web_common_h5_pipeline/workspace/fe-h5/smart-form/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis\" ><circle cx=\"21.888\" cy=\"22\" r=\"4.045\"/><circle cx=\"5.913\" cy=\"22\" r=\"4.045\"/><circle cx=\"37.863\" cy=\"22\" r=\"4.045\"/></symbol>";
module.exports = sprite.add(image, "ellipsis");


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/assets/ellipsis.svg
// module id = 488
// module chunks = 0 1